import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../contexts/CartContext";
import { useNav } from "../../contexts/NavContext";
import Icon from "../../ui/Icon";

export default function Nav2({ scrolled, setScrolled, setCategory }) {
  // Navigates
  const navigate = useNavigate();

  // Refs
  const searchInputRef = useRef(null);

  // Handlers
  const handleSecondNavContent = (e) => {
    if (
      e.target.textContent === "Equipment" ||
      e.target.textContent === "Apparel" ||
      e.target.textContent === "Footwear"
    ) {
      setCategory(e.target.textContent.toLowerCase());
      setNav2Content(true);
    }
  };

  // Contexts
  const { search, setSearch, setIsSidebarOpen, setNav2Content } = useNav();
  const { cartItems, setCartOpen } = useCart();

  // Effects
  useEffect(() => {
    if (search && searchInputRef.current) searchInputRef.current.focus();
    search
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [search]);

  return (
    <>
      <div
        className={`fixed left-0 z-20 flex h-[5rem] w-full items-center justify-between bg-white px-4 shadow-xl transition-all duration-300 2xl:px-20 ${search && "hidden"} ${scrolled && "xl:h-14"}`}
      >
        {/* Hamburger and search icons */}
        <div className="flex items-center gap-4 xl:hidden">
          <img
            src="/icons/menu.png"
            alt="Hamburger"
            className="h-5 w-5 cursor-pointer"
            onClick={() => setIsSidebarOpen((open) => !open)}
          />
          <img
            src="/icons/search-outline.png"
            alt="Search"
            className="h-5 w-5 cursor-pointer lg:hidden"
            onClick={() => setSearch((open) => !open)}
          />
        </div>

        {/* Unordered list items */}
        <ul
          onMouseOver={handleSecondNavContent}
          className="hidden font-medium uppercase xl:flex xl:items-center xl:gap-4 2xl:gap-6"
        >
          <li className="cursor-pointer tracking-wide hover:underline">
            Equipment
          </li>
          <li className="cursor-pointer tracking-wide hover:underline">
            Apparel
          </li>
          <li className="cursor-pointer tracking-wide hover:underline">
            Footwear
          </li>
          <li className="cursor-pointer tracking-wide hover:underline">Sale</li>
        </ul>

        {/* Noya athletic logo */}
        <div
          className="absolute left-1/2 -translate-x-1/2 cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img
            src="/logo1.png"
            alt="Noya athletic"
            className={`h-[4rem] transition-all duration-300 ${scrolled && "xl:h-12"}`}
          />
        </div>

        {/* User and cart icons */}
        <div className="flex cursor-pointer items-center gap-4">
          <img
            src="/icons/search-outline.png"
            alt="Search"
            className="hidden h-5 w-5 cursor-pointer lg:block"
            onClick={() => setSearch((open) => !open)}
          />
          <img
            src="/icons/user-outline.png"
            alt="User"
            className="h-5 w-5 cursor-pointer"
            onClick={() => navigate("/account/login")}
          />
          {/* Shopping cart and quantity container */}
          <div
            className="relative"
            onClick={() => setCartOpen((open) => !open)}
          >
            {/* Shopping cart image */}
            <img
              src="/icons/shopping-cart-outline.png"
              alt="Shopping Cart"
              className="h-5 w-5 cursor-pointer"
            />
            {/* Quantity span */}
            {cartItems.length > 0 && (
              <span className="absolute -right-2 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-black text-xs text-white">
                {cartItems.length}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Search Nav */}
      {search && (
        <div
          className={`pointer-events-auto sticky left-0 top-0 z-20 h-[5rem] bg-white px-4 ${scrolled && "xl:h-14"}`}
        >
          <div className="flex h-full items-center justify-center gap-2">
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Search"
              className="w-full border border-black p-2 text-black outline-none placeholder:text-inherit md:w-4/5 lg:w-3/5 2xl:w-2/5"
            />
            <Icon textColor="black" onClick={() => setSearch((open) => !open)}>
              <ion-icon name="close-outline" size="large"></ion-icon>
            </Icon>
          </div>
        </div>
      )}

      {/* Background Overlay on click of the search */}
      {search && (
        <div
          className={`fixed bottom-0 left-0 right-0 top-[8.5rem] lg:top-[8rem] ${scrolled && "xl:top-14"} z-50 bg-black bg-opacity-40`}
        ></div>
      )}
    </>
  );
}
